/**
 * Meta-supported WhatsApp message template language codes.
 * Source: Meta Business Messaging "Supported Languages" documentation.
 * UI may offer search over this list; API validates against it on create.
 */
export const WHATSAPP_TEMPLATE_SUPPORTED_LANGUAGE_CODES = [
    "af",
    "sq",
    "ar",
    "ar_EG",
    "ar_AE",
    "ar_LB",
    "ar_MA",
    "ar_QA",
    "az",
    "be_BY",
    "bn",
    "bn_IN",
    "bg",
    "ca",
    "zh_CN",
    "zh_HK",
    "zh_TW",
    "hr",
    "cs",
    "da",
    "prs_AF",
    "nl",
    "nl_BE",
    "en",
    "en_GB",
    "en_US",
    "en_AE",
    "en_AU",
    "en_CA",
    "en_GH",
    "en_IE",
    "en_IN",
    "en_JM",
    "en_MY",
    "en_NZ",
    "en_QA",
    "en_SG",
    "en_UG",
    "en_ZA",
    "et",
    "fil",
    "fi",
    "fr",
    "fr_BE",
    "fr_CA",
    "fr_CH",
    "fr_CI",
    "fr_MA",
    "ka",
    "de",
    "de_AT",
    "de_CH",
    "el",
    "gu",
    "ha",
    "he",
    "hi",
    "hu",
    "id",
    "ga",
    "it",
    "ja",
    "kn",
    "kk",
    "rw_RW",
    "ko",
    "ky_KG",
    "lo",
    "lv",
    "lt",
    "mk",
    "ms",
    "ml",
    "mr",
    "nb",
    "ps_AF",
    "fa",
    "pl",
    "pt_BR",
    "pt_PT",
    "pa",
    "ro",
    "ru",
    "sr",
    "si_LK",
    "sk",
    "sl",
    "es",
    "es_AR",
    "es_CL",
    "es_CO",
    "es_CR",
    "es_DO",
    "es_EC",
    "es_HN",
    "es_MX",
    "es_PA",
    "es_PE",
    "es_ES",
    "es_UY",
    "sw",
    "sv",
    "ta",
    "te",
    "th",
    "tr",
    "uk",
    "ur",
    "uz",
    "vi",
    "zu",
];
const SUPPORTED_LANGUAGE_SET = new Set(WHATSAPP_TEMPLATE_SUPPORTED_LANGUAGE_CODES);
export function isWhatsAppTemplateLanguageCode(value) {
    return SUPPORTED_LANGUAGE_SET.has(value);
}
//# sourceMappingURL=whatsapp-template-locales.js.map